export type PublishState = 'PUBLISHED' | 'NOT_PUBLISHED' | 'PREVIEW_CHANGED';
